import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-box-clock',
  templateUrl: './status-box-clock.component.html',
  styleUrls: ['./status-box-clock.component.scss'],
  standalone: false
})
export class StatusBoxClockComponent {
  @Input()
  textContent = '';

  @Input()
  spanId = '';
}
